import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";

interface TwinkleStarSvgProps {
	className?: string;
	style?: CSSProperties;
}

function TwinkleStarSvg(prop: TwinkleStarSvgProps) {
	const { className, style } = prop;
	return (
		<svg
			viewBox="0 0 24 24"
			fill="var(--brand-2)"
			className={cn("jana-twinkle", className)}
			style={style}
			aria-hidden
		>
			<path d="M12 2c0 4-1 7-3 9s-5 3-9 3c4 0 7 1 9 3s3 5 3 9c0-4 1-7 3-9s5-3 9-3c-4 0-7-1-9-3s-3-5-3-9z" />
		</svg>
	);
}

export default TwinkleStarSvg;
